// src/components/assistant/ChatPage.tsx
//
// Chat embebido (reachable en /m/assistant/chat, DENTRO del navbar de módulos).
// La experiencia full-screen tipo ChatGPT vive en /chat (AssistantShell).
// Este wrapper delgado reusa ChatPane para no duplicar la lógica de conversación.

import { ChatPane } from './ChatPane';

interface ChatPageProps {
  /** Headers extra inyectados por el shell (incluye x-org-id). */
  webChatHeaders?: Record<string, string>;
}

export function ChatPage({ webChatHeaders = {} }: ChatPageProps) {
  return (
    <div className="h-[calc(100vh-140px)]">
      <ChatPane webChatHeaders={webChatHeaders} />
    </div>
  );
}

export default ChatPage;
